import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import classNames from 'classnames'

import { FamilyMember } from 'core/application/employeeDashboard/getReimbursed/reimbursementRequest/familyMembers/getFamilyMembersApi'

import { Button, DefaultSelect, Option } from 'common/components'

import { ME_VALUE } from './getReimbursed/savePremiumExpense'

type SelectFamilyMemberProps = {
  inputName: string
  onChange: (arg: any) => any
  familyMembers: FamilyMember[]
  defaultValue?: any
  label?: string
  placeholder?: string
  labelStyles?: string
  showRequiredSign?: boolean
  canSelectMe?: boolean
}

const SelectFamilyMember = ({
  inputName,
  onChange,
  familyMembers,
  defaultValue = undefined,
  label,
  placeholder,
  showRequiredSign = true,
  labelStyles = '',
  canSelectMe = true,
}: SelectFamilyMemberProps) => {
  const { t: translate } = useTranslation(['ee-dashboard', 'translation'])
  const [open, setOpen] = useState(false)

  const handleDropdownVisibleChange = (open: boolean) => {
    setOpen(open)
  }

  return (
    <DefaultSelect
      label={label || 'Who was this expense for?'}
      labelStyles={classNames(labelStyles || 'mb-12')}
      name={inputName}
      placeholder={placeholder || translate('get-reimburse.request.expense-for-placeholder')}
      className="expense_for_select"
      showRequiredSign={showRequiredSign}
      onChange={(e) => {
        handleDropdownVisibleChange(false)
        onChange(e)
      }}
      defaultValue={defaultValue}
      onClick={() => {
        !open && handleDropdownVisibleChange(true)
      }}
      onDropdownVisibleChange={handleDropdownVisibleChange}
      open={open}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Button
            className="w-100 flex flex__align_center"
            type="text"
            icon="fa fa-plus"
            onClick={() => {
              onChange('add')
              handleDropdownVisibleChange(false)
            }}
          >
            {translate('get-reimburse.request.add-family-member-label')}
          </Button>
        </>
      )}
    >
      {canSelectMe && (
        <Option key={ME_VALUE} value={ME_VALUE}>
          {translate('get-reimburse.request.me-label')}
        </Option>
      )}
      {familyMembers?.map((item: FamilyMember) => (
        <Option key={item.id} value={item.id}>
          {item.firstName} {item.lastName}
        </Option>
      ))}
    </DefaultSelect>
  )
}

export default SelectFamilyMember
